import {
  Box,
  Button,
  DialogTitle,
  Divider,
  ListItemText,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { ModalHeader } from "../../common/modalHeader";

export const PaymentmodeModal = ({ open, setOpen, callback }) => {
  const [data, setData] = useState({
    paymentMethod: "Cash", // Fixed key spelling: paymentMethod
    transactionDetails: "",
  });

  const handleTagsChange = (e) => {
    const { value } = e.target;
    setData({
      ...data,
      paymentMethod: value, // Corrected typo from paymentMedthod to paymentMethod
    });
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          // padding: "10px",
          width: { xs: "80%", sm: "40%", md: "35%", lg: "35%", xl: "35%" },

          overflowY: "auto",
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "3%", sm: "25%", md: "25%", lg: "25%", xl: "25%" },

          top: "10%",
          zIndex: "999999999",
        }}
      >
        {/* <DialogTitle
            color="primary"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: "0px 10px !important",
            }}
          >
            Employee Payroll Details 
            <CloseIcon
              sx={{ float: "right", cursor: "pointer" }}
              onClick={() => setOpen(false)}
            />
          </DialogTitle> */}

        <ModalHeader
          title={"Employee Payroll Details"}
          onClose={(data) => {
            setOpen(data);
          }}
        />
        {/* <Divider /> */}
        <Box
          sx={{
            px: 4,
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: "500",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            Payment Mode
          </Typography>

          <Select
            sx={{
              mt: 1,
              px: 2,
              py: 0.5, // ✅ vertical padding
              height: "40px",
              margin: "0px 10px",
              px: 2,
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "primary.main",
                borderWidth: "2px",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "primary.main",
                borderWidth: "2px",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "primary.main",
                borderWidth: "2px",
              },
            }}
            labelId="tags-label"
            id="services"
            name="tags"
            size="small"
            value={data?.paymentMethod}
            onChange={handleTagsChange}
            input={
              <OutlinedInput
                // label="Payment Method"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              />
            }
            MenuProps={{
              disablePortal: true,
              PaperProps: {
                sx: {
                  zIndex: 2000,
                  mt: 1,
                },
              },
            }}
          >
            <MenuItem value={"Online"}>
              <ListItemText
                // primary={"Employee Name"}
                primaryTypographyProps={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  fontFamily: "Montserrat",
                }}
                primary={"Online"}
              />
            </MenuItem>
            <MenuItem value={"Cash"}>
              <ListItemText
                primaryTypographyProps={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  fontFamily: "Montserrat",
                }}
                primary={"Cash"}
              />
            </MenuItem>
            <MenuItem value={"Cheque"}>
              <ListItemText
                primaryTypographyProps={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  fontFamily: "Montserrat",
                }}
                primary={"Cheque"}
              />
            </MenuItem>
          </Select>
        </Box>

        <Box sx={{ mt: 1, px: 4 }}>
          <Typography
            sx={{
              fontWeight: "500",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            Transaction / Cheque No.
          </Typography>
          <TextField
            fullWidth
            id="transactionDetails"
            size="small"
            // label="Transaction Details"
            value={data?.transactionDetails}
            onChange={(e) => {
              setData({
                ...data,
                transactionDetails: e.target.value,
              });
            }}
          />
        </Box>
        <Box sx={{ p: 1 }} display="flex" justifyContent="center">
          <Button
            sx={{
              mt: 1,
              width: "50%",
              backgroundColor: "#01008B",
              fontWeight: "600",
              borderRadius: "4px",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            variant="contained"
            onClick={() => {
              setOpen(false);
              callback(data);
            }}
          >
            Add
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
